export default __webpack_public_path__ + "static/media/img_3.91d1f6f5.JPG";